const COLLECTION_LABELS = {
  impression: 'Impression',
  session: 'Session',
  integration: 'Integration',
  bucketrans: 'Bucket Transactions',
}

export const COLLECTION_METRICS = {
  impression: [
    { key: 'total', label: 'Total', type: 'count' },
    { key: 'revenue', label: 'Revenue', type: 'sum', field: 'revenue' },
    { key: 'completed', label: 'Completed', type: 'count' },
    { key: 'notCompleted', label: 'Not Completed', type: 'count' },
    { key: 'uniqUser', label: 'Unique Users', type: 'cardinality', field: 'uniqUser' },
    { key: 'uniqUserSession', label: 'Unique User Sessions', type: 'cardinality', field: 'uniqUserSession' },
    { key: 'uniqPathSession', label: 'Unique Path Sessions', type: 'cardinality', field: 'uniqPathSession' },
    { key: 'fraud', label: 'Fraud', type: 'count' },
    { key: 'notFraud', label: 'Not Fraud', type: 'count' },
    { key: 'completedPC', label: 'Completed %', derived: true },
    { key: 'notCompletedPC', label: 'Not Completed %', derived: true },
    { key: 'fraudPC', label: 'Fraud %', derived: true },
    { key: 'notFraudPC', label: 'Not Fraud %', derived: true },
    { key: 'uniqPathSessionPC', label: 'Unique Path Sessions %', derived: true },
    { key: 'rpi', label: 'RPI', derived: true },
    { key: 'rps', label: 'RPS', derived: true },
    { key: 'rpu', label: 'RPU', derived: true },
    { key: 'rpus', label: 'RPUS', derived: true },
  ],
  session: [
    { key: 'total', label: 'Total', type: 'count' },
    { key: 'revenue', label: 'Revenue', type: 'sum', field: 'revenue' },
    { key: 'cost', label: 'Cost', type: 'sum', field: 'cost' },
    { key: 'uniqUser', label: 'Unique Users', type: 'cardinality', field: 'uniqUser' },
    { key: 'duplicated', label: 'Duplicated', type: 'count' },
    { key: 'duplicatedData', label: 'Duplicated Data', type: 'count' },
    { key: 'duplicatedClick', label: 'Duplicated Click', type: 'count' },
    { key: 'tcpaconsent', label: 'TCPA Consent', type: 'count' },
    { key: 'converted', label: 'Converted', type: 'count' },
    { key: 'convertedTrue', label: 'Converted True', type: 'count' },
    { key: 'completed', label: 'Completed', type: 'count' },
    { key: 'scrub', label: 'Scrub', type: 'count' },
    { key: 'fraudConversion', label: 'Fraud Conversion', type: 'count' },
    { key: 'fraudCheckTrue', label: 'Fraud Check True', type: 'count' },
    { key: 'fraudCheckFalse', label: 'Fraud Check False', type: 'count' },
    { key: 'fraudNotCheck', label: 'Fraud Not Check', type: 'count' },
    { key: 'awaitingFraudCheck', label: 'Awaiting Fraud Check', type: 'count' },
    { key: 'margin', label: 'Margin', derived: true },
    { key: 'convertedPC', label: 'Converted %', derived: true },
    { key: 'convertedTruePC', label: 'Converted True %', derived: true },
    { key: 'duplicatedPC', label: 'Duplicated %', derived: true },
    { key: 'duplicatedClickPC', label: 'Duplicated Click %', derived: true },
    { key: 'duplicatedDataPC', label: 'Duplicated Data %', derived: true },
    { key: 'tcpaconsentPC', label: 'TCPA Consent %', derived: true },
    { key: 'scrubPC', label: 'Scrub %', derived: true },
    { key: 'completedPC', label: 'Completed %', derived: true },
    { key: 'uniqUserPC', label: 'Unique Users %', derived: true },
    { key: 'fraudConversionPC', label: 'Fraud Conversion %', derived: true },
    { key: 'fraudCheckTruePC', label: 'Fraud Check True %', derived: true },
    { key: 'fraudCheckFalsePC', label: 'Fraud Check False %', derived: true },
    { key: 'fraudNotCheckPC', label: 'Fraud Not Check %', derived: true },
    { key: 'awaitingFraudCheckPC', label: 'Awaiting Fraud Check %', derived: true },
    { key: 'fraudProjectedPC', label: 'Fraud Projected %', derived: true },
    { key: 'marginPC', label: 'Margin %', derived: true },
    { key: 'cpc', label: 'CPC', derived: true },
    { key: 'rpc', label: 'RPC', derived: true },
    { key: 'cpfc', label: 'CPFC', derived: true },
    { key: 'rpfc', label: 'RPFC', derived: true },
    { key: 'rps', label: 'RPS', derived: true },
    { key: 'rpu', label: 'RPU', derived: true },
    { key: 'cps', label: 'CPS', derived: true },
    { key: 'cpu', label: 'CPU', derived: true },
  ],
  integration: [
    { key: 'total', label: 'Total', type: 'count' },
    { key: 'uniqSession', label: 'Unique Sessions', type: 'cardinality', field: 'session' },
    { key: 'medianLatency', label: 'Median Latency', type: 'percentiles', field: 'latency', options: { percents: [50] } },
    { key: 'successCalls', label: 'Success Calls', type: 'count' },
    { key: 'prepingSuccessful', label: 'Preping Successful', type: 'count' },
    { key: 'prepingRejected', label: 'Preping Rejected', type: 'count' },
    { key: 'rulesSuccessful', label: 'Rules Successful', type: 'count' },
    { key: 'failedCalls', label: 'Failed Calls', type: 'count' },
    { key: 'successCallsPC', label: 'Success Calls %', derived: true },
    { key: 'prepingSuccessfulPC', label: 'Preping Successful %', derived: true },
    { key: 'prepingRejectedPC', label: 'Preping Rejected %', derived: true },
    { key: 'rulesSuccessfulPC', label: 'Rules Successful %', derived: true },
    { key: 'failedCallsPC', label: 'Failed Calls %', derived: true },
  ],
  bucketrans: [
    { key: 'total', label: 'Total', type: 'count' },
    { key: 'balance', label: 'Balance', type: 'sum', field: 'balance' },
    { key: 'credits', label: 'Credits', type: 'sum', field: 'transactionValue' },
    { key: 'cost', label: 'Cost', type: 'sum', field: 'transactionValue' },
    { key: 'min', label: 'Min', type: 'min', field: 'transactionValue' },
    { key: 'max', label: 'Max', type: 'max', field: 'transactionValue' },
    { key: 'avg', label: 'Average', type: 'avg', field: 'transactionValue' },
    { key: 'conversions', label: 'Conversions', type: 'count' },
  ],
}

export const COLLECTIONS = Object.keys(COLLECTION_METRICS).map(value => ({
  value,
  label: COLLECTION_LABELS[value] || value,
}))

export function getMetricDefinition(collection, key) {
  return (COLLECTION_METRICS[collection] || []).find(metric => metric.key === key)
}

export function getCollectionMetricOptions(collection, excludeKeys = []) {
  return (COLLECTION_METRICS[collection] || [])
    .filter(metric => !excludeKeys.includes(metric.key))
    .map(metric => ({ value: metric.key, label: metric.label }))
}

export function definitionToMetric(definition) {
  if (!definition) return { key: 'total', type: 'count', field: '' }

  if (definition.derived) return { key: definition.key, derived: true }

  const metric = { key: definition.key, type: definition.type }
  if (definition.field) metric.field = definition.field
  if (definition.options) metric.options = definition.options
  return metric
}

export function getDefaultMetricForCollection(collection, existingMetrics = []) {
  const catalog = COLLECTION_METRICS[collection] || []
  const definition = catalog.find(
    item => !existingMetrics.some(metric => metric.key === item.key),
  ) || catalog[0]

  return definitionToMetric(definition)
}

export function pruneMetricsForCollection(metrics = [], collection) {
  const available = metrics.filter(
    metric => getMetricDefinition(collection, typeof metric === 'string' ? metric : metric?.key),
  )
  if (available.length) return available

  const fallback = getDefaultMetricForCollection(collection)
  return fallback?.key ? [fallback] : []
}

export function getMetricDisplayLabel(collection, metric) {
  const definition = getMetricDefinition(collection, metric?.key)
  return definition?.label || metric?.key || ''
}

export function hasMetricKey(metrics, key) {
  return metrics.some(metric => metric.key === key)
}

const METRIC_GROUP_ORDER = ['Counts', 'Aggregation', 'Derived', 'Ratio', 'Stats']

function inferMetricGroup(metric) {
  if (metric.derived && metric.key.endsWith('PC')) return 'Ratio'
  if (metric.derived) return 'Derived'
  if (metric.type === 'percentiles' || metric.type === 'stats' || metric.type === 'extended_stats') {
    return 'Stats'
  }
  if (metric.type === 'sum' || metric.type === 'min' || metric.type === 'max' || metric.type === 'avg') {
    return 'Aggregation'
  }
  return 'Counts'
}

export function getGroupedCollectionMetrics(collection) {
  const grouped = {}

  ;(COLLECTION_METRICS[collection] || []).forEach(metric => {
    const group = inferMetricGroup(metric)
    grouped[group] = grouped[group] || []
    grouped[group].push(metric)
  })

  return METRIC_GROUP_ORDER
    .filter(group => grouped[group]?.length)
    .map(group => [group, grouped[group]])
}
